<!-- version 2021/05/20 -->
<template>
    <select id="inputGroupSelect01" class="custom-select">
        <option selected>{{ text }}</option>
        <option value="1">One</option>
        <option value="2">Two</option>
        <option value="3">Three</option>
    </select>
</template>

<script>
    export default {
        name: "SelectBox",
        props: {
            text: String
        }
    }
</script>

<style lang="sass" scoped>

</style>